<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon>receipt_long</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">{{ data.tituloTipo }}</h2>
        <span class="modal-subtitle">{{ data.dataLabel }}</span>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" (click)="fechar()">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content">
    @if (isLoading) {
        <div class="loading-container">
            <app-loading-box width="100%" height="220px"></app-loading-box>
        </div>
    } @else if (itens.length > 0) {
        <table mat-table [dataSource]="itens">
            <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef>Descrição</th>
                <td mat-cell *matCellDef="let item">{{ stripHtml(item.descricao) }}</td>
            </ng-container>
            <ng-container matColumnDef="categoria">
                <th mat-header-cell *matHeaderCellDef>Categoria</th>
                <td mat-cell *matCellDef="let item">{{ item.categoria }}</td>
            </ng-container>
            <ng-container matColumnDef="valor">
                <th mat-header-cell *matHeaderCellDef class="col-valor">Valor</th>
                <td mat-cell *matCellDef="let item" class="col-valor">{{ item.valor | abnt: 'preco': 2 }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <div class="total-row">
            <span>Total</span>
            <strong>{{ valorTotal | abnt: 'preco': 2 }}</strong>
        </div>
    } @else {
        <app-empty-state
            icon="receipt_long"
            title="Nenhum lançamento encontrado"
            subtitle="Não há lançamentos deste tipo para o dia selecionado.">
        </app-empty-state>
    }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
    <button mat-stroked-button class="btn-secondary" (click)="fechar()">Fechar</button>
</mat-dialog-actions>
